import { mockFormField, mockFormFieldset } from '@domgen/dgx-fe-forms/layout';
import { CmsCardForm } from '../../models/cms/cms-card-form.interface';
import { mockCmsBillingAddressFieldset } from './cms-billing-address-fieldset.mock';
import { mockCmsPaperlessPreferenceFieldset } from './cms-paperless-preference-fieldset.mock';

export const mockCmsCardForm: CmsCardForm = {
  accountNameField: mockFormField,
  addressFieldset: mockFormFieldset,
  billingAddressFieldset: mockCmsBillingAddressFieldset,
  cardNumberField: mockFormField,
  cvvField: mockFormField,
  expiryDateField: mockFormField,
  monthlyRenewalField: mockFormField,
  paperlessPreferenceFieldset: mockCmsPaperlessPreferenceFieldset,
};
